// positions of maintain scroll panels will be stored here
var $ = window.$;
window.storedScrollPositions = {};
window.$maintainScrollPanels;
window.trackScrollPositions = function() {
	window.$maintainScrollPanels = $('[data-maintainScrollPosition]');
	if(window.$maintainScrollPanels.length) {
		window.$maintainScrollPanels.on('scroll',function() {
			window.storedScrollPositions[$(this).attr('id')] = $(this).scrollTop();
		});
	}
};

window.restoreScrollPositions = function() {
	if(window.$maintainScrollPanels.length) {
		window.$maintainScrollPanels.each(function() {
			$(this).scrollTop(window.storedScrollPositions[$(this).attr('id')]);
		});
	}
};

/*
   END DEFINITIONS
------------------------*/

$(function() { 
	window.trackScrollPositions();
});
